import { useSelector } from 'react-redux';
import { selectConnectedNetwork } from '../store';
import { isPermittedNetwork } from './connection.helper';

export const usePermittedNetworkStatus = (): boolean => {
  const connectedNetwork = useSelector(selectConnectedNetwork);

  return isPermittedNetwork(connectedNetwork?.chainId);
};
